import React, { useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ConfirmationDialog } from 'components/base/ConfirmationDialog/ConfirmationDialog'
import { TranslationContext } from 'contexts/TranslationContext'
import { selectShowLogActions } from 'selectors/mainView'
import { setLogsEnabled } from 'actions/app'
import { showLogActions } from 'actions/mainView'

export const LogActionsContainer = () => {
  const visible = useSelector(selectShowLogActions)
  const dispatch = useDispatch()
  const { t } = useContext(TranslationContext)

  if (!visible) return null

  return (
    <ConfirmationDialog
      title={t('MODAL_WINDOW_LOGS_TITLE')}
      confirmBtnText={t('MODAL_WINDOW_BUTTON_RESTART')}
      closeBtnText={t('EDITOR_MAIN_SETTINGS_BTN_CANCEL')}
      onCancel={() => dispatch(showLogActions(false))}
      onConfirm={() => {
        dispatch(setLogsEnabled())
        dispatch(showLogActions(false))
      }}
    />
  )
}
